import { createRouter, createWebHashHistory } from "vue-router";

import TestComponent from "./components/TestComponent.vue";
import Chat from "./components/Chat.vue";
import PersonaGrid from "./components/PersonaGrid.vue";
import Interview from "./components/Interview.vue";
import PersonaInfo from "./components/PersonaInfo.vue";
import PersonaManagement from "./components/PersonaManagement.vue";
import PersonaEditPersona from "./components/PersonaEditPersona.vue";
import PersonaFrameworkEditor from "./components/PersonaFrameworkEditor.vue";
import Dashboard from "./components/Dashboard.vue";
import FocusGroup from "./components/FocusGroup.vue";
import GeneratePersonas from "./components/GeneratePersonas.vue";
import PromptManagement from "./components/PromptManagement.vue";
import PromptManagementTemplates from "./components/PromptManagementTemplates.vue";
import PromptManagementTemplateForm from "./components/PromptManagementTemplateForm.vue";
import PromptManagementQuestionDriven from "./components/PromptManagementQuestionDriven.vue";
// import RegisterPage from "./components/RegisterPage.vue";
import LoginPage from "./components/LoginPage.vue";
import { get_current_user_from_storage } from "./api";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      redirect: "/persona",
    },

    // {
    //   path: "/registration",
    //   name: "registration",
    //   component: RegisterPage,
    //   meta: {
    //     public: true,
    //     hideSidebar: true,
    //   },
    // },

    {
      path: "/login",
      name: "login",
      component: LoginPage,
      meta: {
        public: true,
        hideSidebar: true,
      },
    },

    {
      path: "/persona",
      name: "persona",
      component: PersonaGrid,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/persona-info/:id",
      name: "personaInfo",
      component: PersonaInfo,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/persona-management",
      name: "persona-management",
      component: PersonaManagement,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/persona-management/:personaId/edit",
      name: "persona-management-edit",
      component: PersonaEditPersona,
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/persona-management/domains/:domainId/attributes",
      name: "persona-framework-editor",
      component: PersonaFrameworkEditor,
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: "/chat",
      name: "chat",
      component: Chat,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/interview",
      name: "interview",
      component: Interview,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/focus-group",
      name: "focus-group",
      component: FocusGroup,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/info",
      name: "info",
      component: TestComponent,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/generate-personas",
      name: "generate-personas",
      component: GeneratePersonas,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/prompt-management",
      name: "prompt-management",
      component: PromptManagement,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        depth: 1,
      },
    },
    {
      path: "/prompt-management/question-driven",
      name: "prompt-management-question-driven",
      component: PromptManagementQuestionDriven,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        depth: 2,
      },
    },
    {
      path: "/prompt-management/templates",
      name: "prompt-management-templates",
      component: PromptManagementTemplates,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        depth: 2,
      },
    },
    {
      path: "/prompt-management/templates/new",
      name: "prompt-management-template-new",
      component: PromptManagementTemplateForm,
      props: { mode: 'new' },
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        depth: 3,
      },
    },
    {
      path: "/prompt-management/templates/:templateId/view",
      name: "prompt-management-template-view",
      component: PromptManagementTemplateForm,
      props: (route) => ({ templateId: route.params.templateId, mode: 'view' }),
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        depth: 3,
      },
    },
    {
      path: "/prompt-management/templates/:templateId/edit",
      name: "prompt-management-template-edit",
      component: PromptManagementTemplateForm,
      props: (route) => ({ templateId: route.params.templateId, mode: 'edit' }),
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        depth: 3,
      },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/login",
    }
  ],
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("authToken");

  const isPublicRoute = to.meta.public === true;

  if (!token && !isPublicRoute) {
    next("/login");
    return;
  }

  if (
    token &&
    (to.name === "login")
  ) {
    next("/persona");
    return;
  }

  if (to.meta.requiresAdmin) {
    const user = get_current_user_from_storage();
    const isAdmin = user?.is_admin === true
      || user?.role_id === "admin"
      || user?.role_id === "super_admin";
    if (!isAdmin) {
      next("/persona");
      return;
    }
  }

  next();
});

export default router;
